import { Injectable, inject } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { Observable, catchError, map, of, tap } from 'rxjs';
import { AuthDataService } from '../data-access/data/auth-data.service';
import { AuthStoreService } from '../data-access/store/auth-store.service';

@Injectable({ providedIn: 'root' })
export class SessionResolver implements Resolve<boolean | null> {
  private authStoreService = inject(AuthStoreService);
  private authDataService = inject(AuthDataService);
  private router = inject(Router);

  resolve(): Observable<boolean | null> {
    const puId = this.authStoreService.puId();
    const accessToken = this.authStoreService.accessToken();

    if (accessToken) {
      return this.authDataService.getSummary().pipe(
        tap(res => {
          const {
            customer,
            paymentplan,
            feature,
            pu,
            rpAMF,
            agreeToChargeAMF,
            enableAMF,
            confirm_default_payment_method_popup_text_cc,
            confirm_default_payment_method_popup_text_ba,
            defPayMtdType
          } = res;
          const [firstPlan] = paymentplan;

          this.authStoreService.setState({
            rpId: customer.rp,
            rpName: customer.name,
            email: customer.email,
            mobilephone: customer.mobilephone,
            brand: customer.brand,
            puNumber: +pu,
            paymentPlans: paymentplan,
            features: feature,
            baTransactionOwner: firstPlan?.baTransactionOwner ?? '',
            baTransactionFee: firstPlan?.baTransactionFee ?? '',
            rpAMF,
            agreeToChargeAMF,
            enableAMF,
            confirmDefaultPaymentMethodPopupTextCc: confirm_default_payment_method_popup_text_cc,
            confirmDefaultPaymentMethodPopupTextBa: confirm_default_payment_method_popup_text_ba,
            defPayMtdType
          });
        }),
        map(() => true),
        catchError(err => {
          if (err?.status === 422) {
            this.router.navigate(['/error'], {
              queryParams: { code: 422 }
            });
          }
          console.error('Summary error:', err);
          return of(false);
        })
      );
    }

    return this.authDataService.validateToken(puId).pipe(
      tap(res => {
        this.authStoreService.setState({
          rpId: res.rp,
          rpName: res.name,
          email: res.email,
          mobilephone: res.mobilephone,
          brand: res.brand,
          puNumber: +res.pu,
          otpSent: res.otpSent
        });
      }),
      map(() => true),
      catchError(err => {
        if (err?.status === 422) {
          this.router.navigate(['/error'], {
            queryParams: { code: 422 }
          });
        }
        console.error('Token validation error:', err);
        return of(false);
      })
    );
  }
}
